import React from "react";
import OperatingSystemForm, {types} from "./OperatingSystemForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/operatingSystemActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const OperatingSystemCreate = props => {
    const { classes, activeCustomer, translations, permissions } = props;

    const handleSubmit = async data => {
        let objestToSend = {...data};
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        if (objestToSend["Key"] === "") {
            objestToSend["Key"] = null;
        }
        let result = await props.onCreateOperatingSystem({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        LongName: "",
        CustomerID: types && types.length > 0 ? types[0].value : '',
        Key: '',
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations["create_operating_system"] || "Create operating system",
        ButtonSubmit: hasPermission(permissions, "operating_system_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <OperatingSystemForm
                        classes={classes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                        permissions={permissions}
                        CustomerIDPreviousState={''}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateOperatingSystem: operatingSystem => dispatch(actions.createOperatingSystem(operatingSystem))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(OperatingSystemCreate));